module.exports = __webpack_public_path__ + "static/media/key-visual.71239600.jpeg";